import { render, staticRenderFns } from "./NewsMessages.vue?vue&type=template&id=b3e87860&scoped=true"
import script from "./NewsMessages.vue?vue&type=script&lang=js"
export * from "./NewsMessages.vue?vue&type=script&lang=js"
import style0 from "./NewsMessages.vue?vue&type=style&index=0&id=b3e87860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e87860",
  null
  
)

export default component.exports